module.exports = __webpack_public_path__ + "vue/img/suggested-portrait-photo1.53e3c3d8.jpg";